import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  icon: {
    fontSize: UNIT * 1.5,
    color: mainColor.colorBlack
  },
  radio: {
    '&$checked': {
      color: mainColor.secondaryColor
    }
  },
  checked: {},
  label: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 0,
    bottom: 0
  },
  shrink: {
    right: 'unset'
  },
  select: {
    width: UNIT * 6.6875,
    marginRight: UNIT * 1.0625
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.6
  },
  itemSelect: {
    width: UNIT * 12.3125,
    marginRight: UNIT * 1.0625
  }
});